module.exports = __webpack_public_path__ + "img/website.6102c2ec.svg";